import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {CloudflareService} from "../../websites/website/booster/services/cloudflare.service";
import {LoadCacheRules} from "../actions";
import * as cacheRulesActions from '../actions/cache-rules.action';

@Injectable()
export class CacheRulesEffects {

  loadCacheRules$ = createEffect(() => this._actions$.pipe(
    ofType(cacheRulesActions.LOAD_CACHE_RULES),
    mergeMap((action: LoadCacheRules) => {
      return this._cloudflareService.getCacheRules(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new cacheRulesActions.LoadCacheRulesSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new cacheRulesActions.LoadCacheRulesFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _cloudflareService: CloudflareService
  ) {
  }


}
